import React from 'react';
import { FolderIcons } from '../../../../icons/icons';
import { FolderChip } from '../../../../utils/types/candi_bank_types';

/** The folders a candidate is in, as small chips; `max` chips then "+N". */
export const FolderChips: React.FC<{ folders?: FolderChip[]; max?: number }> = ({ folders, max = 2 }) => {
  if (!folders || folders.length === 0) return null;
  return (
    <div className='flex flex-wrap items-center gap-1'>
      { folders.slice(0, max).map((f) => (
        <span
            key={f.id}
            className='inline-flex items-center gap-1 px-1.5 py-0.5 text-[10px] font-semibold rounded border bg-amber-50 text-amber-700 border-amber-100 max-w-[140px]'
            title={f.name}
        >
          <FolderIcons className='w-2.5 h-2.5 shrink-0' />
          <span className='truncate'>{ f.name }</span>
        </span>
      )) }
      { folders.length > max && (
        <span className='text-[10px] text-slate-400' title={folders.slice(max).map((f) => f.name).join(', ')}>
          +{ folders.length - max }
        </span>
      ) }
    </div>
  );
};
